import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    FreeBetContainer,
    FreeBetButton,
    FreeBetDropdown,
    FreeBetItem,
    FreeBetItemContent,
    FreeBetItemLabel,
    FreeBetItemExpire,
    BonusIcon,
    AppliedFreeBetLabel,
    AppliedFreeBetBar,
    AppliedFreeBetAmount,
    AppliedFreeBetContainer,
    CloseButton,
    SmallBonusButton,
} from './FreeBetSelector.style';
import { useCommon } from 'src/AppState/Common';
import {
    FreeBetSelectorState,
    AvailableFreeBetType,
} from 'src/components/BetSlip/BonusEngineFreeBets/FreeBetSelector.state';
import { ConfigState } from 'src/AppState/ConfigState/ConfigState';

export type FreeBetType = {
    id: string | null;
    uid: string | null;
    type: string;
    freeBets: Array<string>;
};

export type FreeBetSelectorPropsType = {
    currency: string;
    currencySymbol: string;
    bonusEngineFreeBets: Array<FreeBetType>;
    userId: number;
    selectedFreeBets: Array<AvailableFreeBetType>;
    betType: string;
    betUid?: string | null;
    toggleFreeBet: (freeBet: AvailableFreeBetType) => void;
    clearFreeBetSelection: (betType: string, betUid?: string | null) => void;
};

export const FreeBetSelector = observer(
    'FreeBetSelector',
    (props: FreeBetSelectorPropsType): React.ReactElement | null => {
        const {
            bonusEngineFreeBets,
            currencySymbol,
            userId,
            selectedFreeBets,
            toggleFreeBet,
            clearFreeBetSelection,
            betType,
            betUid,
        } = props;
        const common = useCommon();
        const config = ConfigState.get(common);
        const [state] = useState<FreeBetSelectorState>(
            new FreeBetSelectorState(bonusEngineFreeBets, betType, userId, common)
        );

        const { toggleDropdown, isDropdownOpen, availableFreeBets } = state;

        const filteredSelectedFreeBets = selectedFreeBets.filter((selectedFreeBet) => selectedFreeBet.type === betType);
        const total = filteredSelectedFreeBets.reduce((sum, bet) => sum + bet.rawAmount, 0);

        return (
            <FreeBetContainer>
                {filteredSelectedFreeBets.length > 0 ? (
                    <AppliedFreeBetContainer>
                        <AppliedFreeBetBar>
                            <AppliedFreeBetLabel>
                                <BonusIcon />
                                <AppliedFreeBetAmount>
                                    {currencySymbol}
                                    {config.precision.newFromAnything(total).toFixed(2)} Applied
                                </AppliedFreeBetAmount>
                            </AppliedFreeBetLabel>
                            <CloseButton onClick={() => clearFreeBetSelection(betType, betUid)}>×</CloseButton>
                        </AppliedFreeBetBar>

                        <SmallBonusButton onClick={toggleDropdown}>
                            <BonusIcon />
                        </SmallBonusButton>
                    </AppliedFreeBetContainer>
                ) : (
                    <FreeBetButton onClick={toggleDropdown}>
                        <BonusIcon />
                        FREE BET
                    </FreeBetButton>
                )}

                {isDropdownOpen && (
                    <FreeBetDropdown>
                        {availableFreeBets.map((freeBet) => {
                            const isChecked =
                                selectedFreeBets.find((selectedFreeBet) => {
                                    if (freeBet.type === 'SGL') {
                                        return (
                                            selectedFreeBet.id === freeBet.id &&
                                            selectedFreeBet.selectionId === freeBet.selectionId
                                        );
                                    }
                                    return selectedFreeBet.id === freeBet.id && selectedFreeBet.type === freeBet.type;
                                }) !== undefined;

                            return (
                                <FreeBetItem key={freeBet.id}>
                                    <input
                                        type='checkbox'
                                        checked={isChecked}
                                        onChange={(): void => toggleFreeBet(freeBet)}
                                    />
                                    <FreeBetItemContent onClick={(): void => toggleFreeBet(freeBet)}>
                                        <FreeBetItemLabel>
                                            {currencySymbol}
                                            {freeBet.currentAmount.value} {freeBet.label}
                                        </FreeBetItemLabel>
                                        <FreeBetItemExpire>{freeBet.expiry}</FreeBetItemExpire>
                                    </FreeBetItemContent>
                                </FreeBetItem>
                            );
                        })}
                    </FreeBetDropdown>
                )}
            </FreeBetContainer>
        );
    }
);
